// Generated by ReScript, PLEASE EDIT WITH CARE

import * as EvmWalletJs from "./EvmWallet.js";

function requestDirectProviderTransaction(prim) {
  return EvmWalletJs.requestDirectProviderTransaction(prim);
}

function executeExecutionPlan(prim0, prim1) {
  return EvmWalletJs.executeExecutionPlan(prim0, prim1);
}

export {
  requestDirectProviderTransaction ,
  executeExecutionPlan ,
}
/* ./EvmWallet.js Not a pure module */
